module.exports = __webpack_public_path__ + "static/media/5.a52684c1.JPG";